export default __webpack_public_path__ + "static/media/agency-tablet-side.2fae36b5.webp";